import { format, parseISO } from 'date-fns'

/**
 * Format currency for Indian Rupees
 */
export const formatCurrency = (amount) => {
  if (amount === null || amount === undefined) return '₹0.0'
  const num = parseFloat(amount)
  if (isNaN(num)) return '₹0.0'
  return `₹${num.toLocaleString('en-IN', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  })}`
}

/**
 * Parse admin-held funds from API (string or number). Missing or invalid → 0.
 * Do not subtract from usable balance — server already nets hold into payout figures.
 */
export const parseHeldAmount = (value) => {
  if (value == null || value === '') return 0
  const raw = typeof value === 'number' ? value : String(value).replace(/,/g, '')
  const n = parseFloat(raw)
  return Number.isFinite(n) ? n : 0
}

/**
 * Format date for display
 */
export const formatDate = (date, formatStr = 'MMM dd, yyyy') => {
  if (!date) return '-'
  try {
    const dateObj = typeof date === 'string' ? parseISO(date) : date
    return format(dateObj, formatStr)
  } catch (error) {
    return '-'
  }
}

/**
 * Format date with time (including seconds)
 */
export const formatDateTime = (date) => {
  return formatDate(date, 'MMM dd, yyyy HH:mm:ss')
}

/**
 * Get status badge color
 */
export const getStatusColor = (status) => {
  const statusLower = status?.toLowerCase()
  switch (statusLower) {
    case 'success':
    case 'completed':
      return 'bg-green-100 text-green-800'
    case 'pending':
      return 'bg-yellow-100 text-yellow-800'
    case 'failed':
      return 'bg-red-100 text-red-800'
    default:
      return 'bg-gray-100 text-gray-800'
  }
}

/**
 * Debounce function
 */
export const debounce = (func, wait) => {
  let timeout
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout)
      func(...args)
    }
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
  }
}

/**
 * Validate email
 */
export const isValidEmail = (email) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}

/**
 * Validate IFSC code
 */
export const isValidIFSC = (ifsc) => {
  return /^[A-Z]{4}0[A-Z0-9]{6}$/.test(ifsc)
}

/**
 * Validate account number (basic - at least 9 digits)
 */
export const isValidAccountNumber = (accountNumber) => {
  return /^\d{9,}$/.test(accountNumber)
}

/**
 * Truncate text
 */
export const truncate = (str, length = 20) => {
  if (!str) return ''
  return str.length > length ? `${str.substring(0, length)}...` : str
}

/**
 * Get initial from name
 */
export const getInitials = (name) => {
  if (!name) return 'U'
  const parts = name.trim().split(' ')
  if (parts.length === 1) return parts[0][0].toUpperCase()
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
}

